import { render, staticRenderFns } from "./RoutesSvg.vue?vue&type=template&id=032d2064"
import script from "./RoutesSvg.vue?vue&type=script&lang=js"
export * from "./RoutesSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports